import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import { InputMui } from '../../../../../../components/input-mui/input-mui';
import { secondsToMilliseconds } from '../../../../../../utils/helpers/time-convert';
import { ChannelType } from '../../../../types';
import { useBlindManualCalibration } from '../../hooks/use-blind-manual-calibration';

type BlindManualCalibrationDialogProps = {
  channel: ChannelType;
  showManualDialog: boolean;
  setShowManualDialog: React.Dispatch<React.SetStateAction<boolean>>;
};

export const BlindManualCalibrationDialog: React.FC<BlindManualCalibrationDialogProps> = ({
  channel,
  showManualDialog,
  setShowManualDialog,
}) => {
  const { t } = useTranslation('channel-settings');
  const { t: tc } = useTranslation('common');
  const {
    saveManualCalibrationParams,
    openTimeTemp,
    setOpenTimeTemp,
    closeTimeTemp,
    setCloseTimeTemp,
    calibrateState,
  } = useBlindManualCalibration(channel, setShowManualDialog);

  return (
    <DialogConfirmation
      show={showManualDialog}
      setShow={setShowManualDialog}
      header={t('manualCalibration')}
      primaryBtnText={tc('buttons.save')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnAction={saveManualCalibrationParams}
      secondaryBtnAction={() => setShowManualDialog(false)}
      primaryBtnDisabled={
        calibrateState?.openingMilliseconds === secondsToMilliseconds(Number(openTimeTemp)) &&
        calibrateState?.closingMilliseconds === secondsToMilliseconds(Number(closeTimeTemp))
      }
      contentClassName="p-r-0 p-l-0"
    >
      <div className="grid-list-24">
        <InputMui
          value={openTimeTemp}
          onChange={(e) => setOpenTimeTemp(e.target.value)}
          label={`${t('openingTime')} (s)`}
          reverse
          type="number"
          step={0.1}
        />
        <InputMui
          value={closeTimeTemp}
          onChange={(e) => setCloseTimeTemp(e.target.value)}
          label={`${t('closingTime')} (s)`}
          reverse
          type="number"
          step={0.1}
        />
      </div>
    </DialogConfirmation>
  );
};
